import React, { useCallback } from 'react';
import { useGetJobQuery } from '@diditusa/shared/api/jobsApi';
import { useParams } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import { useCreateCheckoutSessionMutation } from '@diditusa/shared/api/checkoutApi';
import { EmbeddedCheckout, EmbeddedCheckoutProvider } from '@stripe/react-stripe-js';
import LoadingIndicator from '@diditusa/shared/web_components/LoadingIndicator/loadingIndicator';
import { Box } from '@mui/material';

const stripePromise = loadStripe(
  'pk_live_51RChH0A9ZV9nP2j29hLrKIhOiUF63AOB9miYC0QwLl9los8GzvIWpIdbGp0bKw7oblm6AOmF4w7iW1cZ71x9UzEA000oscIWWT',
);

export default function Checkout() {
  const { jobId } = useParams();
  const { data: job, ...getJobState } = useGetJobQuery(parseInt(jobId!));
  const [createCheckoutSession, createCheckoutSessionState] = useCreateCheckoutSessionMutation();
  const fetchClientSecret = useCallback(async () => {
    // Create a Checkout Session
    if (!job) {
      return '';
    }
    const session = await createCheckoutSession({ job });
    return session.data!.clientSecret;
  }, [job]);

  if (getJobState.isLoading) {
    return <LoadingIndicator isVisible={getJobState.isLoading} />;
  }

  if (getJobState.isError) {
    return <p>Error getting job: {(getJobState.error as any).data.message}</p>;
  }

  if (!job) {
    return <p>Unknown error occurred. Try again later...</p>;
  }

  const options = { fetchClientSecret };
  let content = <EmbeddedCheckout />;
  // if (createCheckoutSessionState.isLoading) {
  //   content = <LoadingIndicator isVisible={createCheckoutSessionState.isLoading} />;
  // }

  // if (createCheckoutSessionState.isError) {
  //   content = (
  //     <p>Error creating checkout: {(createCheckoutSessionState.error as any).data.message}</p>
  //   );
  // }

  return (
    <Box mt={'64px'}>
      <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
        {content}
      </EmbeddedCheckoutProvider>
    </Box>
  );

  // Figure out what details you need to create the checkout session
}
